import styled from 'styled-components';
import { Box, Text } from '@rsos/base-components';

export const AddressBox = styled(Box).attrs({
  marginBottom: '4px',
  horizontal: true,
  justify: 'space-between',
  flow: 16,
})``;

export const StyledSource = styled(Text).attrs({
  color: 'secondaryText',
  size: 'xsmall',
})``;
